import Main from './Main.vue'

export default [{
  path: 'pregao-lance2/:id',
  name: 'pregaolance2',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao-lance2/routes.js